
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { packageDeginationsList } from "../../services/userservice";
import { setPackageDeginations, setError, setLoading as setDeginationsLoading, } from "../../features/common/packageDeginationSlice";

const DestinationsList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const { packageDeginations, loading, error } = useSelector((state) => state.packageDegination);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(setDeginationsLoading());
                const response = await packageDeginationsList();
                dispatch(setPackageDeginations(response));
            } catch (error) {
                dispatch(setError(error.message));
            }
        };
        fetchData();
    }, [dispatch]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    if (loading) return <div>Loading...</div>;

    // Filtered package designations based on the search term
    const filteredPackageDeginations = packageDeginations.filter((item) =>
        item?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );




    // Table rows to show per page Start

    const indexOfLastItem = currentPage * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    const currentItems = filteredPackageDeginations.slice(indexOfFirstItem, indexOfLastItem);

    // bottom pagination start

    const totalPages = Math.ceil(filteredPackageDeginations.length / rowsPerPage);

    const renderPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 3;

        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first 3 pages
            pages.push(1, 2, 3);

            // Show "..." if currentPage is beyond 5
            if (currentPage > 5) {
                pages.push("...");
            }

            // Show current page and neighbors
            const start = Math.max(4, currentPage - 1);
            const end = Math.min(totalPages - 3, currentPage + 1);

            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) pages.push(i);
            }

            // Show "..." if currentPage is far from end
            if (currentPage < totalPages - 4) {
                pages.push("...");
            }

            // Always show last 3 pages
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }

        return pages.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
            >
                {page === "..." ? (
                    <span className="page-link">...</span>
                ) : (
                    <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                    </button>
                )}
            </li>
        ));
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Destination List</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Destination List</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-md-flex align-items-center justify-content-end">
                                        <Link to="/add-destination" className="btn btn-primary mb-md-0 mb-2 py-1 mr-3">
                                            <i className="fas fa-plus" /> Add Deginations
                                        </Link>
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{ width: "250px" }}>
                                                <input
                                                    type="text"
                                                    name="table_search"
                                                    className="form-control float-right"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">

                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "5%" }}>#</th>
                                                    <th style={{ width: "20%" }}>Deginations Name</th>
                                                    <th style={{ width: "10%" }}>Status</th>
                                                    <th style={{ width: "15%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems?.map((category, i) => (
                                                    <tr key={category?.id}>
                                                        <td>{i + 1}</td>
                                                        <td>{category?.name}</td>
                                                        <td>
                                                            <span
                                                                className={`badge p-2 ${category?.status === "active"
                                                                    ? "badge-success"
                                                                    : "badge-danger"
                                                                    }`}
                                                            >
                                                                {category?.status?.toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                <Link to={`/edit-destination/${category.id}`}>
                                                                    <button className="btn btn-primary btn-sm">Edit</button>
                                                                </Link>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredPackageDeginations.length)} of {filteredPackageDeginations.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DestinationsList;
